<script lang="ts">
	import ClientCard from "@components/ClientCard.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import type { ClassValue } from "svelte/elements";
	import type { WebClient } from "@core/schema/WebClient.js";

	const { clients, class: customClass }: { clients: WebClient[]; class?: ClassValue } = $props();
</script>

<section class={[customClass, "full-width py-8 md:py-16 lg:py-20"]}>
	<HugeHeading level={2} text="stroke[[Naši klienti]]" class="text-center mb-1 sm:mb-4" />
	<div class="marquee overflow-hidden" style:--count={clients.length}>
		<div class="marquee-track flex w-max">
			{#each [false, true] as isDuplicate (isDuplicate)}
				<div class="flex shrink-0" aria-hidden={isDuplicate} inert={isDuplicate}>
					{#each clients as client (client.name)}
						<ClientCard {client} class="mx-1" />
					{/each}
				</div>
			{/each}
		</div>
	</div>
</section>

<style lang="postcss">
	.marquee {
		/* Card width (w-40 + mx-1) and speed in multiples of the spacing unit */
		--card-width: calc(theme(spacing.1) * 42);
		--speed: calc(theme(spacing.1) * 30);

		@screen md {
			--card-width: calc(theme(spacing.1) * 74); /* w-72 + mx-1 */
		}
	}

	.marquee-track {
		/* Fallback for browsers without length / length division, which drop the declaration below */
		animation: marquee calc(var(--count) * 2s) linear infinite reverse;
		animation: marquee calc(var(--count) * var(--card-width) / var(--speed) * 1s) linear infinite reverse;
	}

	.marquee:hover .marquee-track {
		animation-play-state: paused;
	}

	@media (prefers-reduced-motion: reduce) {
		.marquee-track {
			animation: none;
		}
	}

	@keyframes marquee {
		to {
			transform: translateX(-50%);
		}
	}
</style>
